import { render } from "./AboutModal.vue?vue&type=template&id=7ebe0e8b"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"

import "./AboutModal.vue?vue&type=style&index=0&id=7ebe0e8b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__